import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';
import { IconMain } from '#components';
import dayjs from 'dayjs';
import { toShortAddress } from '~/utils/helpers';

const columnHelper = createColumnHelper<AppWTFNftEvent>();

export function useTransferHistoryColumns() {
    return [
        columnHelper.accessor('eventType', {
            header: '',
            cell: (info) => {
                const { row } = info;
                const transaction = row.original;

                return h('div', { class: 'display-flex align-items-center gap-12' }, [
                    h('div', { class: 'arrow-block display-flex align-items-center justify-center' }, [
                        h(IconMain, {
                            icon: 'arrow-t-r',
                            size: 16
                        })
                    ]),
                    h('div', { class: 'display-flex flex-column gap-4' }, [
                        h('p', { class: 'compact-400-accent' }, transaction.eventType),
                        h('p', { class: 'text-300-numeric text-color-brand-aviation' }, dayjs.unix(Number(transaction.createdAt || '')).format('YYYY-MM-DD HH:mm'))
                    ])
                ]);
            }
        }),
        columnHelper.accessor('transferDescription.from', {
            header: 'From',
            cell: info => h('span', { class: 'compact-400-accent-numeric' }, toShortAddress(info.getValue()))
        }),
        columnHelper.accessor('transferDescription.to', {
            header: 'To',
            cell: info => h('span', { class: 'compact-400-accent-numeric' }, toShortAddress(info.getValue()))
        }),

        columnHelper.accessor('transferDescription.amount', {
            header: () => h(
                'div',
                { class: 'display-flex flex-nowrap justify-end table-header-left' },
                ['Amount']
            ),
            cell: info => h('div', { class: 'display-flex flex-column gap-4 table-cell-left' }, [
                h('p', { class: 'compact-400-accent' }, info.getValue())
            ])
        })
    ];
}
